import { render, staticRenderFns } from "./DmsUserProfileTabsItems.vue?vue&type=template&id=34524a9c"
import script from "./DmsUserProfileTabsItems.vue?vue&type=script&lang=js"
export * from "./DmsUserProfileTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports